const STORAGE_KEY = 'authHeader'

export const loadAuth = () => {
  try {
    // try to load saved auth from local storage
    const auth = window.localStorage.getItem(STORAGE_KEY)
    if (!auth) {
      return undefined
    }
    return JSON.parse(auth)
  } catch (err) {
    // fail without throwing an error
    return undefined
  }
}

export const saveAuth = ({ header, email, name }) => {
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ header, email, name }),
    )
  } catch (err) {
    // ingore save errors
  }
}



// WEBPACK FOOTER //
// ./src/utils/authLocalStorage.js